import { pipe } from 'fp-ts/function';
import {
    PortfolioBookablePeriod,
    PortfolioCancellationPolicyApplicability,
    PortfolioCentralCancellationPolicyDetail,
} from '@mews-commander/data-access';
import { DurationService } from '@mews/framework';
import { toPercents } from '@mews-commander/utils';
import { FormValues } from '../../../schema';
import { CancellationFeeExtentFieldOption } from '../../../types';
import { CancellationPolicyFormField, CancellationPolicyOffsetType } from '../../../../../cancellationPolicies';

export const getInitialValues = (data?: PortfolioCentralCancellationPolicyDetail | null): FormValues => {
    if (data) {
        const offsetDuration = DurationService.parse(data.applicabilityOffset);
        return {
            ...data,
            [CancellationPolicyFormField.Key]: data.key ?? '',
            [CancellationPolicyFormField.BookablePeriod]: data.bookablePeriod ?? PortfolioBookablePeriod.Night,
            [CancellationPolicyFormField.OffsetType]:
                data.applicability !== PortfolioCancellationPolicyApplicability.Creation &&
                (DurationService.isNegative(offsetDuration) || DurationService.isZero(offsetDuration))
                    ? CancellationPolicyOffsetType.Before
                    : CancellationPolicyOffsetType.After,
            [CancellationPolicyFormField.RelativeFee]: toPercents(data.relativeFee, 4),
            [CancellationPolicyFormField.ApplicabilityOffset]: pipe(
                offsetDuration,
                DurationService.absolute,
                (duration) => DurationService.toObject(duration, { partial: false })
            ),
            [CancellationPolicyFormField.FeeExtent]:
                data.feeExtent && data.feeExtent.length === 1
                    ? CancellationFeeExtentFieldOption[data.feeExtent[0]]
                    : CancellationFeeExtentFieldOption.TimeUnitsAndProducts,
        };
    }
    return {
        key: '',
        absoluteFee: 0,
        relativeFee: 0,
        feeExtent: CancellationFeeExtentFieldOption.TimeUnitsAndProducts,
        bookablePeriod: PortfolioBookablePeriod.Night,
        offsetType: CancellationPolicyOffsetType.After,
        applicabilityOffset: DurationService.toObject(DurationService.parse('PT0S'), { partial: false }),
        applicability: PortfolioCancellationPolicyApplicability.Creation,
    };
};
